import Military, { MilitarySections } from './Military';

export default Military;
export { MilitarySections };
